<template>
    <div class="choose-enterprise-main">
        <div class="choose-enterprise-body">
            <el-container class="companySelectPop">
                <el-aside style="width: 55%;">
                    <div class="tools-bar">
                        <span><el-tag type="primary">企业列表</el-tag></span>
                        <div class="tools-search" @keyup.enter="handleSearchForSelect">
                            <el-input maxlength="100" v-model.trim="companyNameForSelect" placeholder="企业名称">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearchForSelect"></el-button>
                            </el-input>
                        </div>
                    </div>
                    <template v-if="multiple">
                        <el-table  :data="companyForSelectList" @selection-change="handleSelectionChangeForSelect" style="width: 100%;" v-loading="selectLoading" tooltip-effect="dark" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="companyName" label="公司名称"></el-table-column>
                        </el-table>
                    </template>
                    <template v-else>
                        <el-table  :data="companyForSelectList" highlight-current-row @current-change="handleSelectionChangeForSelect" style="width: 100%;" v-loading="selectLoading" tooltip-effect="dark" stripe>
                        <el-table-column prop="companyName" label="公司名称"></el-table-column>
                        </el-table>
                    </template>
                    <!-- 分页 -->
                    <el-row type="flex" justify="end">
                        <el-pagination
                            background
                            layout="total,sizes, prev, pager, next"
                            :total="page.totalPageNum"
                            :current-page="page.currentPage"
                            :page-size="page.pageSize"
                            :page-sizes="[6, 10, 20, 50, 100, 300]"
                            @current-change="queryFormDataForSelect"
                            @size-change="queryFormDataByPageSize"
                            >
                        </el-pagination>
                    </el-row>
                </el-aside>
                <el-aside style="width: 45%;">
                    <div class="tools-bar">
                        <span><el-tag type="success">已选择的企业</el-tag></span>
                        <div class="tools-btn-group">
                            <el-button icon="el-icon-remove" type="danger" @click="handleRemoveSelected">移除</el-button>
                        </div>
                    </div>
                    <el-table ref="multipleTable" :data="selectedItemList" @selection-change="handleSelectionRemoved" tooltip-effect="dark" style="width: 100%;" v-loading="selectLoading" stripe>
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="companyName" label="公司名称"></el-table-column>
                    </el-table>
                </el-aside>
            </el-container>
        </div>
        <div class="choose-enterprise-btn">
            <el-button type="info" @click="cancelClick">取消</el-button> 
            <el-button :loading="companySelectLoading" type="primary" @click="confirmClick">确定</el-button> 
        </div>
    </div>

    
    
</template>

<script>
    import { getCompanyList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import { isEmpty, cloneDeep } from 'lodash';
    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department
        },
        data () {
            return {
                companySelectLoading: false,
                isInnerShowCompany: false,
                isShowTree: false,
                companyNameForSelect: '',
                selectLoading: false,
                companyForSelectList: [],
                page: {
                    currentPage: 1,
                    pageSize: 6,
                    totalPageNum: 1
                },
                selectedItemList: [], // 已选择的企业列表数据
                selectMap: new Map(),
                currentDepartmentId: '', // 当前点击的部门节点
                selectedItemIds: '', // 选中的企业ID
                selectedItemNames: '', // 选中的企业名称
                selectedRemovedItemIds: ''// 选中的企业ID
            };
        },
        props: {
            selectedItem: {
                type: Object,
                default: function () {
                    return {
                        selectedItemIds: '',
                        selectedItemNames: ''
                    };
                }
            },
            multiple: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._initPage();
    
        },
        methods: {
            async _initPage () {
                this.isInnerShowCompany = true;
                this.selectMap = new Map();
                if (!isEmpty(this.selectedItem.selectedItemIds)) {
                    this.selectedItemIds = this.selectedItem.selectedItemIds;
                    this.selectedItemNames = this.selectedItem.selectedItemNames;
                }
                this._getListData();
            },
            async _getListData () {
                await this.handleSearchForSelect();
                await this.handleSearchSelected();
            },
            async handleSearchForSelect () {
                this.selectLoading = true;
                let data = await getCompanyList(this.page.currentPage, this.page.pageSize, this.companyNameForSelect);
                this.companyForSelectList = cloneDeep(data.data);
                // this.companyForSelectList = companyNameForSelectList.data;
                this.page.currentPage = data.currentPage;
                this.page.pageSize = data.pageSize;
                this.page.totalPageNum = data.totalPageNum;
                this.selectLoading = false;
            },
            queryFormDataForSelect (currentPage) {
                this.page.currentPage = currentPage;
                this._getListData();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this._getListData();
            },
            async handleSearchSelected () {
                this.selectLoading = true;
                if (!isEmpty(this.selectedItemIds)) {
                    let ids = this.selectedItemIds.split(',');
                    let names = this.selectedItemNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], companyName: names[i]});
                    }
                    this.selectedItemList = selectedData;
                } else {
                    this.selectedItemList = [];
                }
                this.selectLoading = false;
            },
            async handleRemoveSelected () {
                if (!isEmpty(this.selectedRemovedItemIds)) {
                    let newIds = this.selectedRemovedItemIds.split(',');
                    let ids = this.selectedItemIds.split(',');
                    let names = this.selectedItemNames.split(',');
                    let selectedData = [];
                    this.selectedItemIds = '';
                    this.selectedItemNames = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], companyName: names[i]});
                            if (isEmpty(this.selectedItemIds)) {
                                this.selectedItemIds = ids[i];
                                this.selectedItemNames = names[i];
                            } else {
                                this.selectedItemIds = this.selectedItemIds + ',' + ids[i];
                                this.selectedItemNames = this.selectedItemNames + ',' + names[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedItemList = selectedData;
                }
            },
            handleSelectionChangeForSelect (rows) {
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedItemIds)) {
                                        this.selectedItemIds = row.id;
                                        this.selectedItemNames = row.companyName;
                                    } else {
                                        this.selectedItemIds = this.selectedItemIds + ',' + row.id;
                                        this.selectedItemNames = this.selectedItemNames + ',' + row.companyName;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedItemIds = rows.id;
                        this.selectedItemNames = rows.companyName;
                    }
                    this.handleSearchSelected();
                }
            },
            handleSelectionRemoved (rows) {
                this.selectedRemovedItemIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedItemIds)) {
                                this.selectedRemovedItemIds = row.id;
                            } else {
                                this.selectedRemovedItemIds = this.selectedRemovedItemIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            confirmClick () {
                let param = {};
                param.selectedItemIds = this.selectedItemIds;
                param.selectedItemNames = this.selectedItemNames;
                this.$emit('confirm', param);
            },
            cancelClick () {
                this.$emit('cancel');
            }
        }
    };
</script>

<style lang="less">
    .choose-enterprise-main{
        .choose-enterprise-body{
            .companySelectPop {
                height: 365px;
                .el-header {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .el-main {
                    padding: 0;
                }
        
                .el-aside {
                    border-right: 1px solid #dcdfe6;
                }
            }
        }
        .choose-enterprise-btn{
            text-align: right;
            padding-right: 20px;
            position: relative;
            top: 20px;
            margin: 10px 0px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/CompanySelectPop/CompanySelectPop.vue